import React from 'react'
import AttributeList from '../components/products/AttributeList'

function AttributesPage() {
  return <AttributeList />
}

export default AttributesPage
